import axios from './index.js'
// import axios from 'axios'

// //角色管理
const getAllRolesByOrgId = params => {
  return axios.post('/role/GetAllRolesByOrgId',
    params
  )
}

const deleteRole = params => {
  return axios.post('/role/delete',
    params
  )
}
const listRole = params => {
  return axios.post('/role/list',
    params
  )
}
const batchRemoveUser = params => {
  return axios.get('/user/batchremove', { params })
}

const editUser = params => {
  return axios.post('/user/editUser',
    params
  )
}
const addRole = params => {
  return axios.post('/role/add',
    params
  )
}
const editRole = params => {
  return axios.post('/role/edit',
    params
  )
}

const ahtucMenu = params => {
  return axios.post('/role/authcMenu',
    params
  )
}
const ahtucEdit = params => {
  return axios.post('/role/authcEdit',
    params
  )
}

// 菜单管理
const listAllMenu = params => {
  return axios.get('/menu/listAllMenu', { params })
}

const menuList = params => {
  return axios.post('/menu/menus',
    params
  )
}
const menuAdd = params => {
  return axios.post('/menu/add',
    params
  )
}
const menuDel = params => {
  return axios.post('/menu/delete',
    params
  )
}
const menuDetail = params => {
  return axios.post('/menu/detail',
    params
  )
}
const menuEdit = params => {
  return axios.post('/menu/edit',
    params
  )
}
const authnButton = params => {
  return axios.post('/button/authnButton', params)
}

const authnButtonEdit = params => {
  return axios.post('/button/authnButtonEdit',
    params
  )
}

// 本地请求地址
// export const urls = 'http://localhost:12000' //本地
export const urls = 'http://www.eco-earth.cc:43063'// 正式

export {
  getAllRolesByOrgId,
  listRole,

  deleteRole,
  batchRemoveUser,
  editUser,
  editRole,
  ahtucMenu,
  ahtucEdit,
  addRole,
  listAllMenu,
  menuList,
  menuAdd,
  menuDel,
  menuDetail,
  menuEdit,
  authnButton,
  authnButtonEdit

}
